import { api } from '../../lib/api-client';

/**
 * Comments del cliente sobre talents (§4.5 — SW-502). Edit/delete por author.
 * Soft delete: cuando `deletedAt != null`, el `text` viene como string vacío y el FE
 * muestra placeholder. La cronología (`createdOn`) se preserva.
 */
export type CommentItem = {
  /** `ClientTalentComment.PublicKey` Guid. */
  id: string;
  authorEmail: string;
  authorFullName: string | null;
  text: string;
  createdOn: string;
  updatedOn: string | null;
  deletedAt: string | null;
};

export type ListCommentsResponse = {
  items: CommentItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
};

export type ListCommentsParams = {
  shortlistPublicKey: string;
  talentPublicKey: string;
  pageNumber?: number;
  pageSize?: number;
};

export type CreateCommentParams = {
  shortlistPublicKey: string;
  talentPublicKey: string;
  text: string;
};

export type UpdateCommentParams = {
  commentPublicKey: string;
  text: string;
};

export type DeleteCommentParams = {
  commentPublicKey: string;
};

export async function listTalentComments(
  params: ListCommentsParams,
): Promise<ListCommentsResponse> {
  const search = new URLSearchParams();
  if (params.pageNumber) search.set('pageNumber', String(params.pageNumber));
  if (params.pageSize) search.set('pageSize', String(params.pageSize));
  const qs = search.toString();
  const base =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/comments`;
  return api.get<ListCommentsResponse>(qs ? `${base}?${qs}` : base);
}

export async function createTalentComment(
  params: CreateCommentParams,
): Promise<CommentItem> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/comments`;
  return api.post<CommentItem>(url, { text: params.text });
}

export async function updateTalentComment(
  params: UpdateCommentParams,
): Promise<CommentItem> {
  const url = `/api/client/comments/${params.commentPublicKey}`;
  return api.put<CommentItem>(url, { text: params.text });
}

export async function deleteTalentComment(
  params: DeleteCommentParams,
): Promise<CommentItem> {
  const url = `/api/client/comments/${params.commentPublicKey}`;
  return api.delete<CommentItem>(url);
}
